import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-30"
}
const _hoisted_2 = { class: "h4m text-center" }
const _hoisted_3 = {
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"display":"inline","fill":"#0094ab"}
}
const _hoisted_4 = { class: "d-inline-block" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6-sm" }
const _hoisted_8 = { class: "col-6-sm" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6 text-left" }
const _hoisted_11 = { class: "col-6 text-right" }
const _hoisted_12 = {
  key: 1,
  class: "p-30"
}
const _hoisted_13 = {
  key: 2,
  class: "p-30"
}
const _hoisted_14 = {
  key: 0,
  class: "button__subtitle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_vue_address = _resolveComponent("vue-address")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'d-inline-block': _ctx.small, 'mr-20': _ctx.small, 'ml-20': _ctx.small})
  }, [
    _createVNode(_component_modal, { name: _ctx.modalName }, {
      default: _withCtx(() => [
        (!_ctx.submitSuccess && !_ctx.submitError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("path", { d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" }, null, -1 /* CACHED */)
                ]))])),
                _createElementVNode("span", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createTextVNode(_toDisplayString(_ctx.defaultModalTitle), 1 /* TEXT */)
                  ])
                ])
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("div", {
                class: "error",
                style: {"display":"none"}
              }, null, -1 /* CACHED */)),
              _createElementVNode("form", _hoisted_5, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "pb-20" }, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_input_text, {
                      "input-type": "text",
                      name: "firstname",
                      modelValue: _ctx.firstname,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
                      label: "First Name",
                      placeholder: "First Name",
                      "validation-state": _ctx.v$.firstname
                    }, null, 8 /* PROPS */, ["modelValue", "validation-state"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_input_text, {
                      "input-type": "text",
                      name: "lastname",
                      modelValue: _ctx.lastname,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastname) = $event)),
                      label: "Last Name",
                      placeholder: "Last Name",
                      "validation-state": _ctx.v$.lastname
                    }, null, 8 /* PROPS */, ["modelValue", "validation-state"])
                  ])
                ]),
                _createVNode(_component_input_text, {
                  "input-type": "text",
                  name: "email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                  label: "Email",
                  placeholder: "Email",
                  "validation-state": _ctx.v$.email
                }, null, 8 /* PROPS */, ["modelValue", "validation-state"]),
                _createVNode(_component_input_text, {
                  "input-type": "text",
                  name: "telephone",
                  modelValue: _ctx.telephone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.telephone) = $event)),
                  label: "Telephone",
                  placeholder: "Telephone",
                  "validation-state": _ctx.v$.telephone
                }, null, 8 /* PROPS */, ["modelValue", "validation-state"]),
                _createVNode(_component_vue_address, {
                  large: true,
                  modelValue: _ctx.address,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address) = $event)),
                  ref: "address",
                  email: _ctx.email,
                  "validation-state": _ctx.v$.address
                }, null, 8 /* PROPS */, ["modelValue", "email", "validation-state"]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "pb-20" }, null, -1 /* CACHED */)),
                _createVNode(_component_checkbox, {
                  name: "privacy",
                  "form-value": "yes",
                  modelValue: _ctx.privacy,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.privacy) = $event)),
                  "validation-state": _ctx.v$.privacy
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" By proceeding, I agree that Regit.cars and its automotive partners may contact me by email, telephone or text message with information about other automotive services I agree for my personal data to be used in accordance with the ", -1 /* CACHED */),
                    _createElementVNode("a", {
                      href: "/privacy-policy",
                      target: "_blank"
                    }, "Privacy Policy", -1 /* CACHED */),
                    _createTextVNode(" and to the Terms and Conditions of this website.", -1 /* CACHED */),
                    _createElementVNode("br", null, null, -1 /* CACHED */)
                  ]))], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "validation-state"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "button button--medium button--ghost",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                    }, "Close")
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "button button--medium",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitEnquiry && _ctx.submitEnquiry(...args)))
                    }, "Submit Request ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.submitSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", null, [
                _createTextVNode(" Thank you for your interest in a " + _toDisplayString(_ctx.make) + " " + _toDisplayString(_ctx.model) + ".", 1 /* TEXT */),
                _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Someone from the regit.cars team will be in touch very shortly.", -1 /* CACHED */))
              ]),
              _createElementVNode("button", {
                class: "button button--medium button--hover",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
              }, "Close")
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.submitError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _cache[18] || (_cache[18] = _createElementVNode("p", null, " A generic error happened, please contact the site administration. ", -1 /* CACHED */)),
              _createElementVNode("button", {
                class: "button button--medium button--hover",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
              }, "Close")
            ]))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["name"]),
    _createElementVNode("button", {
      class: _normalizeClass(_ctx.buttonClasses),
      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.show && _ctx.show(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1 /* TEXT */),
      (_ctx.subtitle !== '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createTextVNode(_toDisplayString(_ctx.subtitle), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}